export * from './page-permission.interface';
export * from './product-line-permission.interface';
export * from './rules-permission.interface';
export * from './tab-permission.interface';
export * from './setup-permission.interface';
export * from './setup-page-permission.interface';
export * from './setup-page.interface';
export * from './portal-permissions.interface';
export * from './tab-setup.interface';
export * from './portal2-permissions.interface';
export * from './portal2-role.interface';
export * from './portal2-portal-role.interface';
